// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__Mc5Er","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__1F3Ha"};